import {setTimeout} from "timers";
<template>
  <v-layout v-if="!$store.getters.getMobilePhoneActive" justify-center align-start row wrap>
  <v-card class="themeBackgroundPassport v-card--flat">
    <v-card class="mb-5 v-card--flat">
      <div class="containerForPassport">
        <mapOverview :properties="mapOverviewProps" style="width: 100vw;"></mapOverview>
      </div>
      <v-card class="midSectionDetails v-card--flat">
        <v-layout column justify-center class="midSectionDetails">
          <v-flex pt-4>
            <v-layout row wrap>
              <template>
                <v-card :color="switchContent === 1 ? $vuetify.theme.primary : 'white lighten-1'" :dark="switchContent === 1"
                        @click="switchContent = 1" class="toggleProducts">
                  <v-layout justify-center align-center column fill-height>
                    <v-icon>ti-ticket</v-icon>
                    <h4><b>{{$translate('ACTIVITIES')}}</b></h4>
                  </v-layout>
                </v-card>
              </template>
              <v-card
                color="grey lighten-2"
                class="toggleDisabledProducts"
                v-if="Object.keys(chosenActivity).length === 0"
              >
                <v-layout justify-center align-center column fill-height>
                  <v-icon color="grey lighten-1">event</v-icon>
                  <h4 class="grey--text text--lighten-1"><b>{{$translate('PLANBOARD')}}</b></h4>
                </v-layout>
              </v-card>
              <v-card
                :color="switchContent === 2 ? $vuetify.theme.primary : 'white lighten-1'"
                :dark="switchContent === 2"
                @click="switchContent = 2" class="toggleProducts"
                v-else
              >
                <v-layout justify-center align-center column fill-height>
                  <v-icon>event</v-icon>
                  <h4><b>{{$translate('PLANBOARD')}}</b></h4>
                </v-layout>
              </v-card>
              <v-card
                :color="switchContent === 3 ? $vuetify.theme.primary : 'white lighten-1'"
                :dark="switchContent === 3"
                @click="switchContent = 3" class="toggleProducts"
              >
                <v-layout justify-center align-center column fill-height>
                  <v-icon>history</v-icon>
                  <h4><b>{{$translate('HISTORY')}}</b></h4>
                </v-layout>
              </v-card>
            </v-layout>
          </v-flex>

          <v-flex>
            <h1 class="titleTriplist text-xs-center"
                :style="`color: ${$vuetify.theme.primary}`">{{ title }}</h1>
              <v-layout row align-center justify-center v-if="switchContent === 2">
                  <v-card class="selectDate elevation-0">
                    <v-layout align-center justify-center>
                      <v-btn
                        fab
                        flat
                        @click="datesIndex -= 6"
                        :disabled="datesIndex <= 0"
                      >
                        <v-icon large color="primary">navigate_before</v-icon>
                      </v-btn>
                      <div
                        v-for="index in planBoardDays.slice(datesIndex, 6 + datesIndex)"
                        :key="index"
                      >
                        <v-btn fab @click="changeCalendarDate(index)">
                          {{index.split("-").reverse().splice(0,2).join("-")}}
                        </v-btn>
                      </div>
                      <v-btn fab flat>
                        <v-icon
                          large
                          color="primary"
                          @click="datesIndex += 6"
                          :disabled="datesIndex + 6 >= planBoardDays.length">navigate_next</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card>
              </v-layout>
            </v-flex>

          <h1
            v-if="switchContent === 2"
            class="text-xs-center eventDescriptionTitle selectedDate"
            :style="`color: ${$vuetify.theme.primary}`"
          >{{todayDate.split("-").reverse().join("-")}}</h1>

            <template v-if="tripPlanning == false">
              <v-list two-line class="listOfActivities" v-if="switchContent === 1">
                <div>
                  <v-card class="elevation-0 transparent">
                    <template v-if="userTriplist.length == 0">
                      <h3 class="ml-4 mt-2">{{$translate('LINDA_NO_APPOINTMENTS')}}</h3>
                    </template>
                    <template v-else v-for="(item, index) of userTriplist">
                      <v-list-tile
                        v-if="item.Name !== 'NULL'"
                        class="tripDetails elevation-0"
                        :key="index"
                        @click="setSelectedActivity(item)"
                      >
                        <v-avatar class="activityimg">
                          <img v-if="!item.Picture == ''" :src="item.Picture">
                          <img
                            v-else
                            src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                          >
                        </v-avatar>
                        <v-list-tile-content>
                          <h3>{{ item.Name }}</h3>
                          <v-list-tile-sub-title>{{item.StartDate}}, {{item.StartTime}} - {{item.EndTime}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-chip :style="`background-color: rgba(240, 52, 52, 0.8)`" text-color="white" v-if="item.Status === 'Unconfirmed'">{{$translate('UNCONFIRMED')}}
                        </v-chip>
                        <v-chip :style="`background-color: rgba(0, 230, 64, 0.8)`" text-color="white" v-if="item.Status === 'Confirmed'">{{$translate('CONFIRMED')}}
                        </v-chip>
                        <v-chip :style="`background-color: rgba(240, 52, 52, 0.8)`" text-color="white" v-if="item.Status === 'PartnerConfirmation'">PartnerConfirmation
                        </v-chip>
                        <v-chip :style="`background-color: rgba(240, 52, 52, 0.8)`" text-color="white" v-if="item.Status === 'RequestedPayment'"> RequestedPayment
                        </v-chip>
                        <v-chip v-if="item.Status === 'Done' || item.Status === 'NoShow'">{{item.Status}}</v-chip>
                        <v-chip :style="`background-color: rgba(25, 181, 254, 1)`" text-color="white" v-if="item.Status === 'WaitingForPayment'">
                          {{$translate('WAITING_FOR_PAYMENT')}}
                        </v-chip>
                        <v-chip color="orange" text-color="white" v-if="item.Status === 'Arrived'">{{$translate('ARRIVED')}}
                        </v-chip>
                        <v-btn
                          v-if="item.Status === 'RequestedPayment' || item.Status === 'WaitingForPayment' || item.Status === 'Created'"
                          round
                          primary
                          flat
                          @click="confirmOrder(item)"
                        >
                          <v-icon>euro_symbol</v-icon>
                        </v-btn>
                        <v-dialog v-model="dialog" persistent max-width="290" v-if="item.Status === 'Unconfirmed' || item.Status == 'WaitingForPayment'">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              round
                              primary
                              flat
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title class="headline">Are you sure you want to cancel this activity?</v-card-title>
                            <v-card-actions>
                              <v-btn
                                color="error"
                                flat
                                @click="dialog = false"
                              >
                                <v-icon style="margin-right: 0.5em">thumb_down</v-icon><v-spacer></v-spacer>Cancel
                              </v-btn>
                              <v-btn
                                color="primary"
                                flat
                                @click="cancelBooking(item)"
                              >
                                <v-icon style="margin-right: 0.5em">thumb_up</v-icon><v-spacer></v-spacer>I accept
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-icon large>keyboard_arrow_right</v-icon>
                      </v-list-tile>
                      <v-divider
                        v-if="index + 1 < userTriplist.length"
                        :key="index + 'divider'"
                      ></v-divider>
                    </template>
                  </v-card>
                </div>
              </v-list>
              <v-list two-line class="listOfActivities" v-if="switchContent === 3">
                <div>
                  <v-card class="elevation-0 transparent">
                    <template v-if="userTriplist.length == 0">
                      <h3 class="ml-4 mt-2">{{$translate('LINDA_NO_APPOINTMENTS')}}</h3>
                    </template>
                    <template v-else v-for="(item, index) of doneActivities">
                      <v-list-tile
                        v-if="item.Name !== 'NULL'"
                        class="tripDetails elevation-0"
                        :key="index"
                      >
                        <v-avatar class="activityimg">
                          <img v-if="!item.Picture === ''" :src="item.Picture">
                          <img
                            v-else
                            src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                          >
                        </v-avatar>
                        <v-list-tile-content>
                          <h3>{{ item.Name }}</h3>
                          <v-list-tile-sub-title>{{item.StartDate}}, {{item.StartTime}} - {{item.EndTime}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-btn v-if="!item.Reviewed"
                               color="primary"
                               style="text-transform: none;"
                               round
                               @click="addOrRemoveFromReviewList(item)">
                          {{$translate('REVIEW_WRITE')}}
                        </v-btn>
                      </v-list-tile>
                      <v-card class="v-card--flat"
                              v-if="writingReviewList.includes(item.OrderId)">
                        <h3>{{$translate('NAME')}}: {{userData[11]}}</h3>
                        <v-rating v-model="item.Rating"
                                  color="yellow darken-3"
                                  background-color="yellow darken-3"/>
                        <v-layout row>
                          <v-textarea
                          v-model="item.Review"
                          auto-grow
                          :label="$translate('REVIEW')"
                          color="primary"
                          rows="1"
                          />
                          <v-btn color="primary"
                                 @click="addReview(item)"
                                 round>
                            {{$translate('SEND')}}
                            <v-icon style="margin-left: 8px;">send</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-card>
                      <v-divider
                        v-if="index + 1 < userTriplist.length"
                        :key="index + 'divider'"
                      ></v-divider>
                    </template>
                  </v-card>
                </div>
              </v-list>
            </template>
            <template v-if="tripPlanning == true">
              <v-card color="white" class="mb-4 tripListStyle mr-2 ml-2 pt-5 pb-1 px-5">
                <CustomerSelectionWishlist v-on:click="getFullTrip()"></CustomerSelectionWishlist>
              </v-card>
            </template>

              <v-layout row>
                <!--Daily Activities list-->
                <v-flex xs8>
                  <template v-if="tripPlanning === false">
                    <v-list two-line v-if="switchContent === 2" class="dailyActivitiesList">
                      <div>
                        <v-card class="elevation-0 transparent">
                          <template v-for="(event, index) in userActivities">
                            <v-list-tile
                              v-if="event.date === todayDate && (event.Depth !== 0 && event.EventType !== 'Trip')"
                              class="tripDetails elevation-0"
                              :key="index"
                              @click="setSelectedActivity(item)"
                            >
                              <v-avatar class="activityimg">
                                <img v-if="event.Picture !== ''" :src="event.Picture">
                                <img
                                  v-else
                                  src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                                >
                              </v-avatar>
                              <v-list-tile-content>
                                <h3>{{ event.Name }}</h3>
                                <v-list-tile-sub-title>{{event.StartDate}}, {{event.StartTime}} - {{event.EndTime}}
                                </v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider
                              v-if="index + 1 < userTriplist.length && event.date === todayDate && (event.Depth !== 0 && event.EventType !== 'Trip')"
                              :key="index + 'divider'"
                            ></v-divider>
                          </template>
                          <template v-for="(product, index) in userProducts">
                            <v-list-tile
                              v-if="product.date === todayDate && (product.Depth !== 0 && product.EventType !== 'Trip')"
                              class="tripDetails elevation-0"
                              :key="index"
                              @click="setSelectedActivity(item)"
                            >
                              <v-avatar class="activityimg">
                                <img v-if="product.Picture !== ''" :src="product.Picture">
                                <img
                                  v-else
                                  src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                                >
                              </v-avatar>
                              <v-list-tile-content>
                                <h3>{{ product.Name }}</h3>
                                <v-list-tile-sub-title>{{product.Price}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider
                              v-if="index + 1 < userTriplist.length && product.date === todayDate && (product.Depth !== 0 && product.EventType !== 'Trip')"
                              :key="index + 'divider'"
                            ></v-divider>
                          </template>
                        </v-card>
                      </div>
                    </v-list>
                  </template>
                </v-flex>

                <!--Planboard-->
                <v-flex xs8>
                  <v-sheet height="75vh" class="calendarBlock" v-if="switchContent === 2">
                  <v-calendar
                    @click:time="(event)=>getOnTripCalendar(event,true)"
                    ref="calendar"
                    :now="todayDate"
                    :value="todayDate"
                    color="primary"
                    type="day"
                    :interval-format="intervalFormat"
                    hide-header
                  >
                    <template slot="dayBody" slot-scope="{ date, timeToY, minutesToPixels }">
                      <template v-for="(event, index) in eventsMap[date]">
                        <div
                          @click="openDialog(event)"
                          v-if="event.StartTime"
                          :key="index"
                          :style="{ top: timeToY(setEventTime(event)) + 'px',
                                    height: minutesToPixels( (setHeightForCalenderItem(event))) + 'px',
                                    background: event.Color}"
                          class="my-event with-time"
                          v-html="event.Name"
                        ></div>
                      </template>
                    </template>
                  </v-calendar>
            </v-sheet>
                </v-flex>

              </v-layout>
        </v-layout>
      </v-card>
      <v-flex xs9 v-if="showTheCalender">
        <v-btn @click="removeCalendar()">{{$translate('CLOSE')}}</v-btn>
        <TripPlanning :properties="calendarProps"></TripPlanning>
      </v-flex>
      <div class="text-xs-center">
        <v-dialog persistent v-model="calendarEditDialog" width="500">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-flex xs9>
                <v-toolbar-title>{{selectedEventToEdit.Name}}</v-toolbar-title>
              </v-flex>
            </v-toolbar>
            <div class="dialogPadding">
              <v-layout column justify-space-between>
                <p>{{$translate('EVENT_CURRENT_START_AND_ENDTIME').replace(/eventName/g,
                  selectedEventToEdit.Name)}}</p>
                <h3>{{selectedEventToEdit.StartTime}} - {{selectedEventToEdit.EndTime}}</h3>
                <p>{{$translate('EVENT_CURRENT_START_AND_ENDDATE').replace(/eventName/g,
                  selectedEventToEdit.Name)}}</p>
                <h3>{{selectedEventToEdit.StartDate}} - {{selectedEventToEdit.EndDate}}</h3>

                <p>{{$translate('EVENT_INSERT_STARTTIME')}}:</p>
                <v-text-field :disabled="startTimeDisabled" v-model="toEditData.StartTime"></v-text-field>
                <p>{{$translate('EVENT_INSERT_ENDTIME')}}:</p>
                <v-text-field :disabled="endTimeDisabled" v-model="toEditData.EndTime"></v-text-field>
              </v-layout>
              <v-layout justify-end align-end>
                <v-btn @click="calendarEditDialog = false">{{$translate('CLOSE')}}</v-btn>
                <v-btn @click="cancelBooking(selectedEventToEdit)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn @click="changeTime()">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-layout>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
            <v-card-text v-if="errorMsg !== ''">{{$translate(String(errorMsg))}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="errorDialog = false">{{$translate('OK')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="noEventsForCalendar"
          width="500"
        >
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              {{$translate('NO_EVENTS')}}
            </v-card-title>
            <v-card-text>
              {{$translate('NO_EVENTS_AVAILABLE')}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="noEventsForCalendar = false"
              >
                {{$translate('CLOSE')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </v-card>
  </v-layout>

  <!--mobile responsive -->

  <v-layout v-else justify-center align-start row wrap>
    <div class="containerForPassportMobile">
      <mapOverview :properties="mapOverviewProps" style="width: 30em; margin-top: -2em;"></mapOverview>
    </div>

    <v-card class="themeBackgroundPassportMobile v-card--flat">
      <v-card class="mb-5 v-card--flat">
          <v-layout row wrap justify-center>
            <template>
              <v-card :color="switchContent === 1 ? $vuetify.theme.primary : 'white lighten-1'" :dark="switchContent === 1"
                      @click="switchContent = 1" class="toggleProductsMobile">
                <v-layout justify-center align-center column fill-height>
                  <v-icon>ti-ticket</v-icon>
                  <h4><b>{{$translate('ACTIVITIES')}}</b></h4>
                </v-layout>
              </v-card>
            </template>
            <v-card
              color="grey lighten-2"
              class="toggleDisabledProductsMobile"
              v-if="Object.keys(chosenActivity).length === 0"
            >
              <v-layout justify-center align-center column fill-height>
                <v-icon color="grey lighten-1">event</v-icon>
                <h4 class="grey--text text--lighten-1"><b>{{$translate('PLANBOARD')}}</b></h4>
              </v-layout>
            </v-card>
            <v-card
              :color="switchContent === 2 ? $vuetify.theme.primary : 'white lighten-1'"
              :dark="switchContent === 2"
              @click="switchContent = 2" class="toggleProductsMobile"
              v-else
            >
              <v-layout justify-center align-center column fill-height>
                <v-icon>event</v-icon>
                <h4><b>{{$translate('PLANBOARD')}}</b></h4>
              </v-layout>
            </v-card>
        </v-layout>
        </v-flex>
      </v-card>
      <v-flex>
        <h1 class="titleTriplistMobile text-xs-center"
            :style="`color: ${$vuetify.theme.primary}`">{{ title }}
        </h1>

        <!--Date list-->
        <v-layout row align-center justify-center v-if="switchContent === 2">
          <v-card class="selectDate elevation-0">
            <v-layout align-center justify-center>
              <v-btn
                fab
                flat
                @click="datesIndex -= 3"
                :disabled="datesIndex <= 0"
              >
                <v-icon large color="primary">navigate_before</v-icon>
              </v-btn>
              <div
                v-for="index in planBoardDays.slice(datesIndex, 3 + datesIndex)"
                :key="index"
              >
                <v-btn fab @click="changeCalendarDate(index)">
                  {{index.split("-").reverse().splice(0,2).join("-")}}
                </v-btn>
              </div>
              <v-btn fab flat>
                <v-icon
                  large
                  color="primary"
                  @click="datesIndex += 3"
                  :disabled="datesIndex + 3 >= planBoardDays.length">navigate_next</v-icon>
              </v-btn>
            </v-layout>
          </v-card>
        </v-layout>
      </v-flex>

      <h1
        v-if="switchContent === 2"
        class="text-xs-center eventDescriptionTitle selectedDate"
        :style="`color: ${$vuetify.theme.primary}`"
      >{{todayDate.split("-").reverse().join("-")}}</h1>

<!--      <template v-if="!tripPlanning">-->
        <v-list two-line class="listOfActivitiesMobile" v-if="switchContent === 1">
          <div>
            <v-card class="elevation-0 transparent">
              <template v-if="userTriplist.length == 0">
                <h3 class="ml-4 mt-2">{{$translate('LINDA_NO_APPOINTMENTS')}}</h3>
              </template>
              <template v-else v-for="(item, index) of userTriplist">
                <v-list-tile
                  v-if="item.Name !== 'NULL'"
                  class="tripDetails elevation-0"
                  :key="index"
                  @click="setSelectedActivity(item)"
                >
                  <v-avatar class="activityimg">
                    <img v-if="!item.Picture == ''" :src="item.Picture">
                    <img
                      v-else
                      src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                    >
                  </v-avatar>
                  <v-list-tile-content>
                    <h3>{{ item.Name }}</h3>
                    <v-list-tile-sub-title>{{item.StartDate}}, {{item.StartTime}} - {{item.EndTime}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-chip color="red" text-color="white" v-if="item.Status == 'Unconfirmed'">{{$translate('UNCONFIRMED')}}
                  </v-chip>
                  <v-chip color="green" text-color="white" v-if="item.Status == 'Confirmed'">{{$translate('CONFIRMED')}}
                  </v-chip>
                  <v-chip v-if="item.Status == 'Done'">{{item.Status}}</v-chip>
                  <v-chip color="blue" text-color="white" v-if="item.Status == 'WaitingForPayment'">
                    {{$translate('WAITING_FOR_PAYMENT')}}
                  </v-chip>
                  <v-chip color="orange" text-color="white" v-if="item.Status == 'Arrived'">{{$translate('ARRIVED')}}
                  </v-chip>
                  <v-icon large>keyboard_arrow_right</v-icon>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < userTriplist.length"
                  :key="index + 'divider'"
                ></v-divider>
              </template>
            </v-card>
          </div>
        </v-list>
<!--      </template>-->

<!--      <template v-if="tripPlanning">-->
        <v-card color="white" class="mb-4 tripListStyle mr-2 ml-2 pt-5 pb-1 px-5">
          <CustomerSelectionWishlist v-on:click="getFullTrip()"></CustomerSelectionWishlist>
        </v-card>
<!--      </template>-->

      <v-layout column>

        <!--Planboard-->
        <v-flex xs8>
          <v-sheet height="75vh" class="calendarBlock" v-if="switchContent === 2">
            <v-calendar
              @click:time="(event)=>getOnTripCalendar(event,true)"
              ref="calendar"
              :now="todayDate"
              :value="todayDate"
              color="primary"
              type="day"
              :interval-format="intervalFormat"
              hide-header
            >
              <template slot="dayBody" slot-scope="{ date, timeToY, minutesToPixels }">
                <template v-for="(event, index) in eventsMap[date]">
                  <div
                    @click="openDialog(event)"
                    v-if="event.StartTime"
                    :key="index"
                    :style="{ top: timeToY(setEventTime(event)) + 'px',
                                    height: minutesToPixels( (setHeightForCalenderItem(event))) + 'px',
                                    background: event.Color}"
                    class="my-event with-time"
                    v-html="event.Name"
                  ></div>
                </template>
              </template>
            </v-calendar>
          </v-sheet>
        </v-flex>
      <!--Daily Activities list-->
      <v-flex xs8>
        <template v-if="tripPlanning === false">
          <v-list two-line v-if="switchContent === 2" class="dailyActivitiesList">
            <div>
              <v-card class="elevation-0 transparent">
                <template v-for="(event, index) in userActivities">
                  <v-list-tile
                    v-if="event.date === todayDate && (event.Depth !== 0 && event.EventType !== 'Trip')"
                    class="tripDetails elevation-0"
                    :key="index"
                    @click="setSelectedActivity(item)"
                  >
                    <v-avatar class="activityimg">
                      <img v-if="event.Picture !== ''" :src="event.Picture">
                      <img
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      >
                    </v-avatar>
                    <v-list-tile-content>
                      <h3>{{ event.Name }}</h3>
                      <v-list-tile-sub-title>{{event.StartDate}}, {{event.StartTime}} - {{event.EndTime}}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider
                    v-if="index + 1 < userTriplist.length && event.date === todayDate && (event.Depth !== 0 && event.EventType !== 'Trip')"
                    :key="index + 'divider'"
                  ></v-divider>
                </template>
                <template v-for="(product, index) in userProducts">
                  <v-list-tile
                    v-if="product.date === todayDate && (product.Depth !== 0 && product.EventType !== 'Trip')"
                    class="tripDetails elevation-0"
                    :key="index"
                    @click="setSelectedActivity(item)"
                  >
                    <v-avatar class="activityimg">
                      <img v-if="product.Picture !== ''" :src="product.Picture">
                      <img
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      >
                    </v-avatar>
                    <v-list-tile-content>
                      <h3>{{ product.Name }}</h3>
                      <v-list-tile-sub-title>{{product.Price}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider
                    v-if="index + 1 < userTriplist.length && product.date === todayDate && (product.Depth !== 0 && product.EventType !== 'Trip')"
                    :key="index + 'divider'"
                  ></v-divider>
                </template>
              </v-card>
            </div>
          </v-list>
        </template>
      </v-flex>
      </v-layout>
    </v-card>
  </v-layout>
</template>
<script>
import MapOverview from '@/components/Map_Overview';
import { mapGetters } from 'vuex';
import BaseObject from '@/objects/BaseObject';
import _ from 'lodash';
import appConfig from '../../config/app_config.js';
import * as dssRequest from '../api/dssRequest';
import LocationObject from '../objects/LocationObject';
import { store } from '../store';
import { ui_helpers } from '../shared/ui_helpers.js';
import BaseComponent from './base/BaseComponent.vue';
import TripPlanning from './TripPlanning';
import CustomerSelectionWishlist from './CustomerSelectionWishlist';

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: 'UserTripList',
  components: {
    TripPlanning,
    CustomerSelectionWishlist,
    MapOverview,
  },
  computed: {
    ...mapGetters({
      _tripForm: 'getTripForm',
      _webStep: 'getWebStepId',
      currentAccountId: 'getCurrentAccountId',
    }),
    title() {
      switch (this.switchContent) {
        case 1:
          return this.$translate('MY_APPOINTMENTS');
        case 2:
          return this.$translate('MY_PLANBOARD');
        case 3:
          return this.$translate('MY_HISTORY');
        default:
          return false;
      }
      // return this.switchContent === 1 ? this.$translate('MY_APPOINTMENTS') : this.$translate('MY_PLANBOARD');
    },
    togglePlanboard() {
      return this.switchPlanboard === true ? this.$translate('TOGGLE_ACTIVITYLIST') : this.$translate('SHOW_PLANBOARD');
    },
    eventsMap() {
      const map = {};
      this.userActivities.forEach((e) => {
        (map[e.date] = map[e.date] || []).push(e);
        if (this.todayDate == e.date) {
          if (Object.keys(map).length > 0) {
            if (e.Type !== 'End') {
              setTimeout(() => {
                this.$refs.calendar.scrollToTime(map[e.date][0].StartTime);
              }, 10);
            } else if (e.Type == 'End') {
              setTimeout(() => {
                this.$refs.calendar.scrollToTime(map[e.date][0].EndTime);
              }, 10);
            }
          }
        }
      });
      return map;
    },
  },
  data: () => ({
    dialog: false,
    // reviews
    userData: {},
    writingReviewList: [],
    // themes
    switchContent: 1,
    themes: {},
    calendarItems: [],
    // Map
    showSmallerMap: false,
    showMap: true,
    // Calendar
    noEventsForCalendar: false,
    calendarItems: [],
    errorDialog: false,
    errorMsg: '',
    toEditData: {},
    userPlanBoard: [],
    showTheCalender: false,
    tripPlanning: false,
    calendarProps: {},
    // Edit time
    startTimeDisabled: false,
    endTimeDisabled: false,
    // Planboard variables
    earlierSelectedEvent: {},
    chosenActivity: {},
    planBoardDays: [],
    userTriplist: [],
    doneActivities: [],
    userActivities: [],
    todayDate: new Date()
      .toLocaleDateString()
      .split('/')
      .reverse()
      .join('-'),
    calendarEditDialog: false,
    selectedEventToEdit: {},
    showPlanBoard: false,
    planBoardAvailable: false,
    togglePlanBoard: false,

    specialGivenCode: '',
    wrongVipCodeDialog: false,
    vipCodeDialog: false,
    properties: {},
    open: [1, 2],
    search: null,
    tripOrderEventData: [],
    chosenTripData: {},
    tripOrder: {},
    eventDetailWindow: false,
    eventData: {},
    confirmDeletion: false,
    tripPlanning: false,
    steps: 0,
    chosenTripId: '',
    disableNext: true,
    chosenTripActivities: [],
    userProducts: {},
    // dailyActivities:[
    //   this.userActivities,
    //   this.userProducts
    // ],
    mapOverviewProps: {
      height: 'height: 25em;',
      showFilterMenu: true,
    },
    datesIndex: 0,
    switchPlanboard: true,
  }),
  created() {
    this.$store.commit('setSeeMapInOprMapQua', false);
    window.scrollTo({
      top: 0,
      left: 0,
    });
  },
  mounted() {
    this.getUserData();
    this.$store.commit('setMAS', true);
    this.getThemes();
    this.$store.commit('setNoBackground', true);
    this.getMyActivities();
    this.$store.commit('setWebStepId', 2);
    // this.getListOfTrips();
  },
  beforeDestroy() {
    this.$store.commit('setMAS', false);
    this.$store.commit('setNoBackground', false);
    this.$store.commit('setLocationsOfUserTripList', {});
  },
  methods: {
    addReview(eventDetails) {
      const payload = {
        Name: this.userData[11],
        Rating: eventDetails.Rating,
        Review: eventDetails.Review,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call addReview on '
              + 'UserTripList.vue was successful', response);
          this.writingReviewList.splice(
            this.writingReviewList.indexOf(eventDetails.OrderId), 1,
          );
          this.markActivityAsReviewed(eventDetails);
        },
        (error) => {
          console.log('The generic call addReview on '
              + 'UserTripList.vue was not successful', error);
        },
        'addReview',
        eventDetails.EventId,
        payload,
        600000,
        false,
      );
    },
    markActivityAsReviewed(eventDetails){
      const payload = {
        ActivityId: eventDetails.UniqueId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call markActivityAsReviewed on '
            + 'UserTripList.vue was successful', response);
          this.getMyActivities();
        },
        (error) => {
          console.log('The generic call markActivityAsReviewed on '
            + 'UserTripList.vue was not successful', error);
        },
        'markActivityAsReviewed',
        this.$store.getters["auth/userName"],
        payload,
        600000,
        false,
      );
    },
    getCurrentDate() {
      // this function is called to get the current day to call the funtion getCalendar()
      const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
      const today = new Date();

      const year = today.getFullYear();
      const month = toTwoDigits(today.getMonth() + 1);
      const day = toTwoDigits(today.getDate());
      return `${day}-${month}-${year}`;
    },
    confirmOrder(item) {
      const payload = {
        Runtime: true,
        OrderId: item.OrderId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The call for confirmOrder on'
              + ' UserTripList.vue was successful', response);
          if (
            response.data.hasOwnProperty('PaymentId')
              && response.data.hasOwnProperty('PaymentUrl')
          ) {
            this.$store.commit('setTripFormPaymentId', response.data.PaymentId);
            // if (this.userOrder.OrderTotalPrice !== "0") {
            const path = response.data.PaymentUrl;
            window.location = path;
            // }
          } else {
            console.log('confirmed trip without payment');
            window.location.reload();
          }
        },
        (error) => {
          console.log('The call for confirmOrder on'
              + ' UserTripList.vue was not successful', error);
        },
        'confirmOrder',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
    createCalendarArrayOfItems(data) {
      // Adding the date to the events and saving the events in array calendarItems
      const recievedData = data;
      for (const [key, value] of Object.entries(recievedData)) {
        value.forEach((element, innerKey) => {
          element.eventDate = key;
          this.calendarItems.push(element);
        });
      }
      this.$store.commit('setCalendar', this.calendarItems);
      if (!_.isEmpty(this.$store.getters.getCalendar)) {
        this.showTheCalender = true;
      }
    },
    getUserData() {
      const payload = {
        RelationType: 'User',
        Id: store.getters['auth/userName'],
        Types: {
          User: 'User',
        },
        StructuredReply: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The call for getUserData on '
              + 'UserTripList.vue was successful', response);
          this.userData = response.data.UserData.User.celldata[0];
        },
        (error) => {
          console.log('The call for getUserData on '
              + 'UserTripList.vue was not successful', error);
        },
        'getUserData',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
    getThemes() {
      let userLanguage = 0;
      if (this.$store.getters.getUserLanguage !== '') {
        userLanguage = this.$store.getters.getUserLanguage;
      }
      const payload = {
        LanguageTagId: Number(userLanguage),
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The call getThemes on '
              + 'UserTripList.vue was successful', response);
          this.themes = response.data.Events;
        },
        (error) => {
          console.log('The call getThemes on '
              + 'UserTripList.vue was not successful', error);
        },
        'getThemesV2',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    getOnTripCalendar(data) {
      this.$store.commit('setAddUserAccommodations', false);
      if (!this.calendarEditDialog) {
        const [year, month, day] = data.date.split('-');
        const newDate = `${day}-${month}-${year}`;

        function compare(clickedTime, startOrEndTime) {
          if (clickedTime > startOrEndTime) {
            return true;
          } if (clickedTime < startOrEndTime) {
            return false;
          }
        }

        let eventAfter = {};
        if (!_.isEmpty(this.eventsMap[data.date])) {
          for (const [index, item] of Object.entries(this.eventsMap[data.date])) {
            if (!compare(data.time, item.StartTime) && !compare(data.time, item.EndTime)) {
              eventAfter = item;
              break;
            }
          }
        }
        const payload = {
          StartTime: data.time,
          EndTime: !_.isEmpty(eventAfter) ? eventAfter.StartTime : '23:59',
          StartDate: newDate,
          EndDate: newDate,
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getOnTripCalendar on '
                + 'UserTripList.vue was successful',
              response,
            );
            for (const [index, item] of Object.entries(response.data.Calendar)) {
              if (!_.isEmpty(response.data.Pictures)) {
                for (const [indexPicture, itemPicture] of Object.entries(
                  response.data.Pictures,
                )) {
                  if (item.PictureId == indexPicture) {
                    item.Picture = itemPicture;
                  }
                }
              }
            }
            if (!_.isEmpty(response.data.Calendar)) {
              this.$store.commit('setCalendar', response.data.Calendar);
              this.showTheCalender = true;
              data.date = newDate;
              data.EndTime = eventAfter.StartTime ? eventAfter.StartTime : '23:59';
              this.$store.commit('setClickedTime', data);
            } else {
              this.noEventsForCalendar = true;
            }
          },
          (error) => {
            console.log(
              'The generic call getOnTripCalendar on '
                + 'UserTripList.vue was not successful',
              error,
            );
          },
          'getOnTripCalendar',
          this.$store.getters['auth/userName'],
          payload,
        );
      }
    },
    intervalFormat(interval) {
      return interval.time;
    },
    intervalFormat(interval) {
      return interval.time;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      this.carouselHeight = 8.1 * window.innerHeight;
    },
    removeCalendar() {
      this.showTheCalender = false;
      this.calendarProps = {};
    },
    getMyActivities() {
      const payload = {
        StartDate: '17-03-2020',
        EndDate: '',
        ActivityType: 'All',
        LocationId: '',
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getMyActivities on '
              + 'UserTripList.vue was successful',
            response,
          );
          if (_.isEmpty(response.data.Activities)) {
            return;
          }
          this.doneActivities = [];
          this.userTriplist = [];
          for (const [index, item] of Object.entries(response.data.Activities)) {
            item.EventType = item.Type;
            if (item.Status !== 'Done') this.userTriplist.push(item);
            else this.doneActivities.push(item);
          }
          this.$store.commit('setLocationsOfUserTripList', this.userTriplist);
          let reversedDate = this.userTriplist[0].StartDate;
          reversedDate = reversedDate.split('-').reverse().join('-');
          this.changeCalendarDate(reversedDate);
        },
        (error) => {
          console.log(
            'The generic call getMyActivities on '
              + 'UserTripList.vue was not successful',
            error,
          );
        },
        'getMyActivities',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
    changeCalendarDate(date) {
      this.todayDate = date;
      this.showPlanBoard = true;
      this.planBoardAvailable = true;
    },
    setSelectedActivity(item) {
      if (item.Type === 'OrderEvent') {
        this.getMyOrder(item.OrderId);
      }
      // Setting the chosen event as the main event
      this.$store.commit('setLocationsOfUserTripList', {});
      this.switchContent = 2;
      this.showSmallerMap = false;
      this.togglePlanBoard = true;
      this.chosenActivity = item;

      this.planBoardDays = [];
      this.userActivities = [];
      this.getMyPlanboard(item);
    },
    getMyOrder(item) {
      this.chosenOrder = {};
      if (!_.isEmpty(this.$store.getters['auth/userName'])) {
        const payload = {
          OrderId: item,
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              'The generic call getMyOrder on '
                + 'UserTripList.vue was successful',
              response,
            );
            this.userProducts = response.data.ProductItems;
          },
          (error) => {
            console.log(
              'The generic call getMyOrder on'
                + ' UserTripList.vue was not successful',
              error,
            );
          },
          'getMyOrder',
          this.$store.getters['auth/userName'],
          payload,
        );
      }
    },
    changeTime() {
      const payload = {
        UniqueId: this.selectedEventToEdit.UniqueId,
        StartDate: this.toEditData.StartDate,
        StartTime: this.toEditData.StartTime,
        EndDate: this.toEditData.EndDate,
        EndTime: this.toEditData.EndTime,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call ChangeTime on '
              + 'UserTripList.vue was successful',
            response,
          );
          this.calendarEditDialog = false;
          this.userPlanBoard = [];
          this.setSelectedActivity(this.userTriplist[0]);
        },
        (error) => {
          console.log(
            'The generic call ChangeTime on '
              + 'UserTripList.vue was not successful',
            error,
          );
          this.errorDialog = true;
          // Defining the error codes
          if (error.errorMsg !== undefined) this.errorMsg = error.errorMsg;
          if (this.errorMsg == '') this.errorMsg = 'E_00_00';
        },
        'changeTime',
        this.$store.getters['auth/userName'],
        payload,
        600000,
        false,
      );
    },
    getMyPlanboard(item) {
      const payload = {};

      if (item.Type === 'Trip') {
        // If the chosen activity is of type 'Trip' set the endDate belonging to the trip
        this.payload = {
          StartDate: item.StartDate,
          EndDate: item.EndDate,
        };
      } else {
        this.payload = {
          StartDate: item.StartDate,
          EndDate: '-1',
        };
      }
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getMyPlanboard on '
              + 'UserTripList.vue was successful',
            response,
          );

          this.userPlanBoard = response.data.PlanBoard;
          console.log('dit werkt', this.userPlanBoard, this.userTriplist);
          for (const [index, item] of Object.entries(this.userPlanBoard)) {
            for (const [key, value] of Object.entries(this.userTriplist)) {
              if (item.UniqueId == value.UniqueId) {
                item.EventType = value.EventType;
              }
            }
          }
          this.planBoardDays = [];
          this.userActivities = [];
          let activityObject = {};
          const combinedObjectsInArray = [];

          const recievedActivitiesToArray = Object.values(this.userPlanBoard);

          recievedActivitiesToArray.forEach((element) => {
            // if (element.Depth != -1) {

            // Setting color for activity
            element.Color = this.getRandomColor(element);
            console.log('element.color', element);
            // Going to store the dates from each activity for the planboard on the planBoardDays variable
            element.date = element.Date.split('-')
              .reverse()
              .join('-');
            if (element.ElementType == 'Daymarker' && element.Type == 'Start') {
              if (!this.planBoardDays.includes(element.date)) {
                this.planBoardDays.push(element.date);
              }
            }
            this.changeCalendarDate(this.planBoardDays[0]);
            // Going to store the activities for the user on the userActivities variable
            this.userTriplist.forEach((tripElement) => {
              if (element.ElementType !== 'Daymarker') {
                // Check if unique ID is equal to element in tripList then push combined object to userActivities
                if (tripElement.UniqueId == element.UniqueId) {
                  activityObject = { ...tripElement, ...element };

                  if (activityObject.StartDate !== activityObject.Enddate) {
                    if (!combinedObjectsInArray.includes(activityObject.UniqueId)) {
                      combinedObjectsInArray.push(activityObject);
                    }
                  } else {
                    combinedObjectsInArray.push(activityObject);
                  }
                }
              }
            });
            // }
          });
          combinedObjectsInArray.forEach((object) => {
            if (object.Type === 'Start' && object.StartDate !== object.EndDate) object.Name += ' (start) ';
            if (object.Type === 'End' && object.StartDate !== object.EndDate) object.Name += ' (end) ';
            if (object.Type === 'Start') {
              if (!this.userActivities.includes(object.UniqueId)) {
                this.userActivities.push(object);
              }
            } else if (object.Type == 'End' && (object.StartDate !== object.EndDate)) {
              this.userActivities.push(object);
            }
          });
          this.showMap = false;
          this.showSmallerMap = true;
          this.togglePlanBoard = true;
        },
        (error) => {
          console.log(
            'The generic call getMyPlanboard on '
              + 'UserTripList.vue was not successful',
            error,
          );
        },
        'getMyPlanboard',
        this.$store.getters['auth/userName'],
        this.payload,
      );
    },
    getRandomColor(element) {
      switch (element.EventType) {
        case 'Theme':
          return 'rgba(255, 30, 30, 0.5)';
          break;
        case 'Main':
          return 'rgba(250, 255, 0,0.5)';

          break;
        case 'Tour':
          return 'rgba(237, 57, 37, 0.5)';
          break;
        case 'DeliveryOrder':
          return 'rgba(64, 116, 229, 0.5)';
          break;
        case 'Relay':
          return 'rgba(51, 183, 53, 0.5)';
          break;
        case 'TakeawayOrder':
          return 'rgba(252, 159, 0, 0.5)';
          break;
        case 'Standard':
          return 'rgba(37, 24, 219, 0.5)';
          break;
        case 'Rental':
          return 'rgba(77, 242, 104, 0.5)';
          break;
        case 'complimentary service':
          return 'rgba(160, 123, 80, 0.5)';
          break;

        default:
          return 'rgba(198, 2, 201, 0.5)';
      }
    },
    cancelBooking(event) {
      this.dialog = false;
      const payload = {
        UniqueId: event.UniqueId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call cancelBooking on '
              + 'UserTripList.vue was successful',
            response,
          );
          this.calendarEditDialog = false;
          window.location.reload();
        },
        (error) => {
          console.log(
            'The generic call cancelBooking on '
              + 'UserTripList.vue was not successful',
            error,
          );
        },
        'cancelBooking',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
    getFullTrip(item, index) {
      this.chosenTripData = item;
      this.chosenTripId = index;
      const payload = {
        Runtime: true,
        TripId: index,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getFullTrip on '
              + 'UserTripList.vue was successful', response);

          this.chosenTripActivities = response.data.Activities;

          this.$store.commit('setTripForm', this.chosenTripData);
          for (const [key, value] of Object.entries(
            this.chosenTripActivities,
          )) {
            value.SeqNr = Number(key);
          }
          this.$store.commit(
            'setTripFormActivities',
            this.chosenTripActivities,
          );
          this.$store.commit('setTripFormTripId', this.chosenTripId);

          this.$store.commit('setWebStepId', 3);
          this.$router.push({
            name: 'MainEventInfo',
            params: 'component',
          });
        },
        (error) => {
          console.log(
            'The generic call getFullTrip on '
              + 'UserTripList.vue was not successful',
            error,
          );
        },
        'getFullTrip',
        this.$store.getters['auth/userName'],
        payload,
      );
    },
    cancelDeleteTrip() {
      this.confirmDeletion = false;
    },
    deleteTrip() {
      const payload = {
        Runtime: true,
        TripId: this.chosenTripId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('the call for deleteTrip on '
              + 'UserTripList.vue was successful', response);
          // this.getListOfTrips();
          this.tripPlanning = false;
        },
        (error) => {
          console.log('The call for deleteTrip on '
              + 'UserTripList.vue was not succesfull', error);
          if (
            error.hasOwnProperty('errorMsg')
              && error.errorMsg == 'E_TL_010'
          ) {
            this.cancelDeleteTrip();
          }
        },
        'deleteTrip',
        this.$store.getters['auth/userName'],
        payload,
      );
      this.chosenTripId = '';
    },
    openDialog(event) {
      this.selectedEventToEdit = event;
      this.toEditData = event;
      if (this.toEditData.TimeWindowType == 'Fixed' && this.toEditData.DurationType == 'Fixed') {
        this.startTimeDisabled = true;
        this.endTimeDisabled = true;
      } else if (this.toEditData.TimeWindowType == 'Repetitive' && this.toEditData.DurationType == 'Fixed') {
        this.startTimeDisabled = false;
        this.endTimeDisabled = true;
      } else {
        this.startTimeDisabled = false;
        this.startTimeDisabled = false;
        this.endTimeDisabled = false;
      }
      this.calendarEditDialog = true;
    },
    setHeightForCalenderItem(event) {
      if (event.StartDate == event.EndDate) {
        if (event.Duration < 1800) {
          event.Duration = 1800;
        }
        return event.Duration / 60;
      }
      return 30;
    },
    addOrRemoveFromReviewList(event) {
      if (this.writingReviewList.includes(event.OrderId)) {
        this.writingReviewList.splice(this.writingReviewList.indexOf(event.OrderId), 1);
      } else this.writingReviewList.push(event.OrderId);
    },
    setEventTime(event) {
      if (event.StartDate == event.EndDate) {
        return event.StartTime;
      } if (event.StartDate !== event.EndDate) {
        if (event.Type == 'Start') {
          return event.StartTime;
        } if (event.Type == 'End') {
          return event.EndTime;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .SelectDateTitle {
    /*min-width: 12em;*/
  }

  .dateOverview {
    cursor: pointer;
    min-width: 6em;
    font-size: 18px !important;
    color: #ededed;
    background-color: none;
    margin: 0 !important;
    padding: 0.5em;
  }

  .dateOverview:hover {
    background-color: grey;
  }

  .SelectDate {
    height: 100%;
    border-radius: 10px !important;
    padding: 0.5em;
    background-color: #ededed;
  }

  .tripListStyle {
    border-radius: 1em !important;
    margin-left: -20em;
  }

  .tripListStyleScroll {
    border-radius: 1em !important;
    overflow-y: auto;
    min-height: 100vh;
  }

  .fontSize {
    font-size: 18px;
  }

  .dialogVIP {
    border-radius: 1em !important;
  }

  .scrollableAuto {
    max-height: 17em;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .tripDetails {
    border-radius: 1em;
    border: none;
    margin-top: 0.3em;
    margin-right: 0.5em;
    margin-left: 0.5em;
    margin-bottom: 0.4em;
  }

  .deleteTrip {
    border-radius: 1em !important;
  }

  .mainText {
    margin-left: -1.5em;
    margin-top: 2em;
    margin-bottom: 0em;
  }

  .subText {
    margin-left: -1.5em;
  }

  .selectionBlock {
    height: 4em;
    margin-right: 0.2em;
    color: #e8e8e8;
  }

  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
  }

  .datesFontSize {
    font-size: 15px;
    color: black;
    padding-top: 1em;
  }

  .rowOfTheDates {
    padding-top: 5vh;
    max-height: 90vh;
    min-height: 90vh;
    overflow: auto;
    background-color: lightgray !important;
    text-align: center;
    min-width: 9em;
  }

  .rowOfTheDates-mobile {
    width: 100%;
    overflow: auto;
    background-color: lightgray !important;
    text-align: center;
    padding: 0 2em;
  }

  .iconClass {
    margin: 0 0.5em;
  }

  .sideBarOnTripList {
    min-height: 65.4em;
  }

  .sideBarOnTripList-mobile {
    width: 100%;
  }

  .listOfActivities {
    padding: 0 1.5em;
    min-height: 90vh;
    background: none !important;
    width: 70em;
  }
  .listOfActivitiesMobile {
    min-height: auto;
    background: none !important;
    width: 100%;
  }

  .selectedActivity:hover {
    background-color: #c1bfbf !important;
    cursor: pointer;
  }

  .titleForTheDate {
    padding: 0 1em;
  }

  .blockWithActivities {
    padding-top: 5vh;
    width: 200%;
    max-height: 75vh;
    overflow-y: auto;
  }

  .dailyActivitiesList {
    width: 100%;
    max-height: 75vh;
    overflow-y: auto;
  }

  .unconfirmed {
    color: red !important;
  }

  .activityimg {
    padding: 5vh;
  }

  .activitytext {
    margin-top: 2.7vh;
    text-shadow: 0 1px 0 black;
  }

  .add {
    margin: 1vh;
    width: 45px;
    height: 45px;
  }

  .calendarBlock {
    width: 100%;
  }

  .dialogPadding {
    padding: 1em;
  }

  .mapOnUserTripListMobile {
    width: 75%;
  }

  .planboardBlock {
    /*min-width: 100%;*/
  }

  .midSectionDetails {
    min-height: 50em !important;
    max-width: 1000px !important;
    margin: auto;
    margin-top: 1em !important;
  }

  .cardClass {
    margin-left: -1em !important;
    margin-top: 5em !important;
    min-height: 50em;
    color: #0087a9;
  }

  .themeBackgroundPassport {
    background: none;
    /*margin-top: 1.2em !important;*/
    margin-left: -1.7em;
    position: relative;
    bottom: 1.5em;
    min-height: 1000px !important;
    width: 100%;
  }
  .themeBackgroundPassportMobile {
    background: none;
    margin-top: 4em !important;
    /*<!--margin-left: -1.7em;-->*/
    position: relative;
    bottom: 1.5em;
    min-height: 1000px !important;
    min-width: 30em;
    width: 100%;
  }

  .containerForPassport {
    padding-top: 0.5em;
    margin: auto;
  }
  .containerForPassportMobile {
    padding-top: 0.5em;

  }

  .toggleProducts {
    cursor: pointer;
    height: 5em;
    width: 23em;
  }
  .toggleProductsMobile {
    cursor: pointer;
    height: 5em;
    width: 40%;
  }
  .toggleDisabledProducts {
    height: 5em;
    width: 23em;
  }
  .toggleDisabledProductsMobile {
    height: 5em;
    width: 40%;
  }

  .titleTriplist {
    margin-bottom: 0.5em;
    margin-top: 0.5em;
    font-size: 50px;
  }
  .titleTriplistMobile {
    margin-top: -0.5em;
    margin-bottom: 0.5em;
    font-size: 50px;
  }

  .selectedDate {
    margin-bottom: 1.2em;
    margin-top: 0.5em;
  }
  .chipText {
    width: 7em;
    text-align: center;
  }
</style>
